import { Component } from 'react'
import { FaUserCircle, FaArrowCircleLeft } from 'react-icons/fa'
import QRCode from 'qrcode.react'
import './topmenu.css'

class TopMenu extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showCard: false,
            showQR: false
        }
    }

    handleProfileSelect() {
        this.props.onSettings()
    }

    handleLogOut() {
        if (this.props.onLogout) this.props.onLogout()
    }

    handleBack() {
        if (this.props.onBack) this.props.onBack()
    }

    handleShowCard() {
        this.setState({ showCard: !this.state.showCard })
        if (this.state.showQR) {
            this.setState({ showQR: false })
        } else setTimeout(() => this.setState({ showQR: true }), 250)
    }

    handleQRClick() {
        if (this.props.card) window.open(`https://gwpp-fhir.com/contact/${this.props.card}`)
    }

    getSettings() {
        return <div className='Settings-Container' style={{ height: this.state.showCard ? '290px' : this.props.card ? '130px' : '80px' }}>
            <div className='Settings-Row'>
                    <div className={`Settings-Button Settings-Venue`} onClick={() => this.handleLogOut()}>Log Out</div>
                </div>
            {
                this.props.card && <div className='Settings-Row'>
                    <div className={`Settings-Button Settings-Card${this.state.showCard ? ' Settings-Current' : ''}`} onClick={() => this.handleShowCard()}>Business Card</div>
                </div>
            }
            {this.state.showQR && this.props.card && <div className='Settings-Row Info-Flex-Wrap'>
                <div style={{ cursor: 'pointer' }} onClick={() => { this.handleQRClick() }}><QRCode value={`https://gwpp-fhir.com/contact/${this.props.card}`} /></div>
            </div>}
        </div>
    }

    render() {
        //console.log(this.state, this.props)
        return <div className={`TopMenu-Container TopMenu-BG-${this.props.mode}`}>
            <div className='TopMenu-Left'>
                {this.props.onBack && <div style={{ marginLeft: '5px' }} className='TopMenu-User' onClick={() => this.handleBack()}><FaArrowCircleLeft /></div>}
            </div>
            <div className='TopMenu-Right'>                
                {
                    this.props.user ? (this.props.user.image ? <div style={{ display: 'flex' }}>
                        <div onClick={() => this.handleProfileSelect()}>
                            <img className={`TopMenu-Img Profile-Premium`} src={`https://hit-uploads.s3.amazonaws.com/public/${this.props.user.image}`} alt={`Welcome ${this.props.user.firstName}`} />
                        </div>
                    </div> :
                        <div className={`TopMenu-User Profile-Premium`} onClick={() => this.handleProfileSelect()}><div style={{ fontSize: '23pt', marginTop: '-11px' }}>{this.props.user.firstName.substring(0, 1)}</div></div>) :
                        <div className='TopMenu-User' onClick={() => this.handleProfileSelect()}><FaUserCircle /></div>
                }
            </div>
            {this.props.displaySettings && this.getSettings()}
        </div>
    }
}

export default TopMenu